import { useQuery } from "@tanstack/react-query";
import { XeroAccount } from "./xero-account.model";
import { apiGetRequest } from "utils/api";

async function fetchXeroAccounts(): Promise<XeroAccount[]> {
	return await apiGetRequest("/xero/accounts");
}

export function useXeroAccounts() {
	return useQuery({
		queryKey: ["xero-accounts"],
		queryFn: fetchXeroAccounts,
		staleTime: 1000 * 60 * 60 * 24, // 24 hours
	});
}